
app.controller('dialog_addWorkCtrl', ['$rootScope', '$scope', '$http', 'NetworkService','AtlasNotification', function ($rootScope, $scope, $http, NetworkService, AtlasNotification) {
    
        $scope.gui = {};
        $scope.gui.okButtonDisabled = true;
        $scope.work = {};
        
        $scope.hasValue = function(model){
            return model != undefined && model != "";
        }
        $scope.formChanged = function(){
            if($scope.hasValue($scope.work.start) && $scope.hasValue($scope.work.end) && $scope.hasValue($scope.work.name)){
                $scope.gui.okButtonDisabled = false;
            }
        }
        
        $scope.addWork = function (){
            var newWork = {
                start: moment($scope.work.start).format("YYYY-MM-DD HH:mm:ss"),
                end: moment($scope.work.end).format("YYYY-MM-DD HH:mm:ss"),
                count: $scope.work.count,
                positionId: $scope.dialogInitVars.alle_positionen_id,
                name: $scope.work.name,
                forAllPositions: $scope.work.forAllPositions,
                eventId: event.Veranstaltungsnummer/*,
                shiftDetailsUnknow: $scope.work.shiftDetailsUnknow*/
            }
            console.log(newWork);
            
            NetworkService.callOperation("addwork", newWork, function(d){
                 AtlasNotification.info("Arbeit erfolgreich hinzugefügt.");
                 $rootScope.$emit("updateCalendar")
             })
        }
    }])